"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "TypeRamp", {
  enumerable: true,
  get: function () {
    return _TypeRamp.TypeRamp;
  }
});
Object.defineProperty(exports, "TypeRampV2", {
  enumerable: true,
  get: function () {
    return _TypeRampV.TypeRampV2;
  }
});
exports.typography = void 0;
var _deprecatedTypeRampConstants = require("./constants/deprecatedTypeRampConstants");
var _lodestarConstants = require("./constants/lodestarConstants");
var _typographyConstants = require("./constants/typographyConstants");
var _TypeRamp = require("./components/TypeRamp");
var _TypeRampV = require("./components/TypeRampV2");
const typography = {
  fontSizeDefinitions: _lodestarConstants.fontSizeDefinitions,
  fontWeight: _typographyConstants.fontWeight,
  fontFamily: _typographyConstants.fontFamily,
  typeRampDefinitions: _deprecatedTypeRampConstants.typeRampDefinitions
};
exports.typography = typography;
//# sourceMappingURL=index.js.map